import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Product, productService } from "~/services/firebaseService";
import AppLayout from "~/pages/AppLayout/AppLayout";
import { Card } from "~/components/Card";

const Products = () => {
  const { t } = useTranslation();
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsData = await productService.getAllProducts();
        setProducts(productsData);
        console.log("Fetched products:", productsData);
      } catch (error) {
        setError("Failed to fetch products");
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleRetry = () => {
    setError(null);
    setLoading(true);
    const fetchProducts = async () => {
      try {
        const productsData = await productService.getAllProducts();
        setProducts(productsData);
      } catch (error) {
        setError("Failed to fetch products");
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  };

  return (
    <AppLayout
      title={t("products.title")}
      loading={loading}
      error={error}
      emptyTitle="No Products Available"
      emptyMessage="We're working on adding new products. Please check back soon!"
      onRetry={handleRetry}
    >
      {products.map((product) => (
        <Card
          key={product.id}
          id={product.id!}
          title={product.title}
          description={product.shortDescription}
          image={product.image}
          href={`/products/${product.id}`}
          category={product.category}
          // meta={{
          //   price: `$${product.price}`,
          //   badge: product.inStock ? `In Stock (${product.stockQuantity})` : 'Out of Stock'
          // }}
        />
      ))}
    </AppLayout>
  );
};

export default Products;
